import React from "react";

export default function PoweredBy() {
  return (
    <div style={{border:"2px solid #184CCF", width:'fit-content',padding:"4px 12px",borderTopLeftRadius:"15px",borderBottomLeftRadius:"15px"}}>
       <span style={{ fontSize:"1em"}}>Powered by {" "}</span>
      <span style={{ color: "var(--secondary-color)" ,fontSize:"1em",fontWeight:"600"}}>COM</span>
      <span style={{ color: "var(--primary-color)",fontSize:"1em",fontWeight:"600" }}>DATA</span>
    </div>
  );
}
